import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { FaCoffee } from 'react-icons/fa';
import { BsGrid3X3Gap } from 'react-icons/bs';
import { MdOutlineTextFields } from 'react-icons/md';

const HomeContainer = styled.div`
  min-height: 100vh;
  padding: 16px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  color: #333;
  margin-bottom: 4px;
  text-align: center;
  width: 100%;
`;

const Subtitle = styled.p`
  margin: 0 0 32px 0;
  text-align: center;
  color: #666;
  font-size: 14px;
`;

const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  max-width: 700px;
`;

const GameCard = styled(motion(Link))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 220px;
  background-color: white;
  border-radius: 16px;
  text-decoration: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  padding: 24px;
`;

const IconWrap = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #541930;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 16px;
`;

const GameName = styled.h2`
  color: #333;
  font-size: 18px;
  margin: 0 0 6px 0;
  text-align: center;
`;

const GameDesc = styled.p`
  color: #888;
  font-size: 13px;
  margin: 0;
  text-align: center;
`;

const CoffeeLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 32px;
  color: #333;
  font-size: 14px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const cardVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { type: 'spring', stiffness: 100, damping: 12 },
  },
};

function Homepage() {
  return (
    <HomeContainer>
      <Title>Coffee Break</Title>
      <Subtitle>Pick a game to play</Subtitle>

      <CardGrid>
        <GameCard to="/wordgame" variants={cardVariants} initial="hidden" animate="visible" whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.98 }}>
          <IconWrap><MdOutlineTextFields /></IconWrap>
          <GameName>Cover</GameName>
          <GameDesc>Find themed words by hopping across the grid like a knight</GameDesc>
        </GameCard>

        <GameCard to="/pebbles" variants={cardVariants} initial="hidden" animate="visible" whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.98 }}>
          <IconWrap><BsGrid3X3Gap /></IconWrap>
          <GameName>Pebbles</GameName>
          <GameDesc>Drag letters onto the board and spell a path from bottom to top</GameDesc>
        </GameCard>
      </CardGrid>

      <CoffeeLink href="https://buymeacoffee.com/coffeebreakgames" target="_blank" rel="noopener noreferrer">
        <FaCoffee /> Support these games
      </CoffeeLink>
    </HomeContainer>
  );
}

export default Homepage;
